// Mock areas for local development testing
export const MOCK_AREAS = [
    { id: 9001, name: "Bokskogen", description: "En vacker bokskog i södra Skåne" },
    { id: 9002, name: "Söderåsen", description: "Nationalpark med dramatiska raviner" },
    { id: 9003, name: "Stenshuvud", description: "Kustnära nationalpark" },
    { id: 9004, name: "Kullaberg", description: "Naturreservat vid havet" },
    { id: 9005, name: "Dalby Söderskog", description: "Urskog med rik flora" },
    { id: 9006, name: "Skrylle", description: "Populärt friluftsområde" },
    { id: 9007, name: "Häckeberga", description: "Slottspark och naturreservat" },
];

export default MOCK_AREAS;
